<template>
    <div class="container">
        <div class="head_bg">
            <common-head></common-head>
            <div class="head_content">
                <img src="../assets/images/justin.png" alt="">
                <div class="head_content_text">
                    <div>“</div>
                    <div>
                        <p>麦学园可能是你第二职业的起点</p>
                        <p>麦学园的宗旨是为麦子们提供再学习的机会，让每一位麦子通过麦学园可以得到成长，为多麦的明天培养更多的优秀人才。</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg_c_w">
            <!-- <div class="body_content">
                <h1>讲师风采</h1>
                <div class="tea_list">
                    <div class="tea_list_items">
                        <img src="../assets/images/elva_avatar.png" alt="">
                        <div>
                            <p>Elva</p>
                            <p>多麦联合创始人&CEO</p>
                            <p>多麦人的道路与自信</p>
                        </div>
                    </div>
                    <div class="tea_list_items">
                        <img src="../assets/images/fifi.png" alt="">
                        <div>
                            <p>Fifi</p>
                            <p>数据分析经理</p>
                            <p>Excel表格应用</p>
                        </div>
                    </div>
                    <div class="tea_list_items">
                        <img src="../assets/images/roy.png" alt="">
                        <div>
                            <p>Roy</p>
                            <p>技术经理</p>
                            <p>技术项目复盘及经验分享</p>
                        </div>
                    </div>
                    <div class="tea_list_items">
                        <img src="../assets/images/wanily.png" alt="">
                        <div>
                            <p>Wanily</p>
                            <p>PHP工程师</p>
                            <p>比特币与区块链技术</p>
                        </div>
                    </div>
                    <div class="tea_list_items">
                        <img src="../assets/images/ryan.png" alt="">
                        <div>
                            <p>Ryan</p>
                            <p>前端开发工程师</p>
                            <p>分析vue2.X响应式原理</p>
                        </div>
                    </div>
                    <div class="tea_list_items">
                        <img src="../assets/images/marico.png" alt="">
                        <div>
                            <p>Marico</p>
                            <p>PHP工程师</p>
                            <p>用最少的代码，做最多的事情</p>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="body_content">
                <h1>麦学园课程</h1>
                <div class="course_list">
                    <div class="bubble_base course_bubble_1 bg_c_o f_s_11 opac_5 animation_1">
                        <span>基层</span>
                        <span>管理</span>
                    </div>
                    <div class="bubble_base course_bubble_2 bg_c_o opac_15"></div>
                    <div class="bubble_base course_bubble_3 bg_c_b opac_15"></div>
                    <div class="bubble_base course_bubble_4 bg_c_b f_s_12 opac_4 animation_2">
                        <span>新人</span>
                        <span>培训</span>
                    </div>
                    <div class="bubble_base course_bubble_5 bg_c_o f_s_9 opac_7 animation_3">
                        <span>运营</span>
                    </div>
                    <div class="bubble_base course_bubble_6 bg_c_o f_s_14 opac_8 animation_4">
                        <span>技术</span>
                    </div>
                    <div class="bubble_base course_bubble_7 bg_c_o f_s_16 animation_5">
                        <span>中层</span>
                        <span>管理</span>
                    </div>
                    <div class="bubble_base course_bubble_8 bg_c_b f_s_12 opac_4 animation_6">
                        <span>网络</span>
                        <span>营销</span>
                    </div>
                    <div class="bubble_base course_bubble_9 bg_c_o opac_15"></div>
                    <div class="bubble_base course_bubble_10 bg_c_o f_s_9 opac_5 animation_1">
                        <span>UI</span>
                        <span>设计</span>
                    </div>
                    <div class="bubble_base course_bubble_11 bg_c_o f_s_12 opac_7 animation_2">
                        <span>产品</span>
                        <span>培训</span>
                    </div>
                    <div class="bubble_base course_bubble_12 bg_c_b f_s_10 opac_4 animation_3">
                        <span>插画</span>
                        <span>设计</span>
                    </div>
                    <div class="bubble_base course_bubble_13 bg_c_b opac_15"></div>
                </div>
            </div>
        </div>

        <div class="bg_c_g">
            <div>
                <h1>学院活动</h1>
                <span @click="handleRouterSkip">查看更多</span>
            </div>
            <div class="activity_list">
                <card v-for="(item,index) in list" :item="item" :key="index" :index="index"></card>
            </div>
        </div>

        <common-footer></common-footer>
    </div>
</template>

<script>
import commonHead from '../components/common-head.vue'
import commonFooter from '../components/common-footer.vue'
import card from '../components/card.vue'
export default {
    data() {
        return {
            page: 1,
            pageSize: 2,
            totalPage: 0,
            cat: 5,
            list: [],
        }
    },
    components: {
        commonHead,
        commonFooter,
        card
    },

    created() {
        const { getActive } = this
        getActive()
    },
    methods: {
        getActive() {
            this.$http
                .get("site/news", {
                    params: {
                        cat: this.cat,
                        Page: this.page,
                        Pagesize: this.pageSize
                    }
                })
                .then(response => {
                    this.list = response.d.Results;
                    this.totalPage = response.d.TotalPage;
                });
        },
        handleRouterSkip() {
            this.$router.push({ name: 'List', query: { cat: this.cat } })
        },
    }

}
</script>

<style lang="less" scoped>
.head_bg {
    background-image: url("../assets/images/banner_mxy.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    & .head_content {
        position: relative;
        height: 155px;
        & img {
            width: 100px;
            height: 135px;
            position: absolute;
            left: 0px;
            bottom: 0;
        }
        & .head_content_text {
            color: #ffffff;
            animation: head_content_text_animation 2s;
            & > div:nth-child(1) {
                width: 22px;
                height: 49.5px;
                opacity: 0.64;
                font-family: Arial-BoldMT;
                font-size: 44px;
                position: absolute;
                top: 42px;
                left: 92px;
            }
            & > div:nth-child(2) {
                position: absolute;
                left: 118px;
                top: 56.5px;
                & > p:first-child {
                    font-size: 16px;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin-bottom: 6px;
                }
                & > p:last-child {
                    width: 241.5px;
                    font-size: 12px;
                    letter-spacing: 0;
                    line-height: 20px;
                }
            }
        }
    }
}
.bg_c_w {
    padding: 36px 20px 0;
    & .body_content {
        padding-bottom: 46px;
        & h1 {
            padding-bottom: 24px;
        }

        & .tea_list {
            display: flex;
            flex-wrap: wrap;
            & .tea_list_items {
                width: 167.5px;
                height: 55px;
                display: flex;
                align-items: center;
                margin-bottom: 16px;
                & img {
                    width: 50px;
                    height: 50px;
                    margin-right: 8px;
                }
                & > div {
                    width: 105px;
                    & > p:nth-child(1) {
                        font-size: 16px;
                        color: #000000;
                        letter-spacing: 0;
                    }
                    & > p:nth-child(2) {
                        font-size: 10px;
                        color: #000000;
                        letter-spacing: 0;
                        padding-bottom: 5px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                    }
                    & > p:nth-child(3) {
                        width: 109.5px;
                        font-size: 10px;
                        color: #666666;
                        letter-spacing: 0;
                        line-height: 13px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
        }

        & .course_list {
            height: 135px;
            position: relative;
            & .course_bubble_1 {
                width: 38px;
                height: 38px;
                left: 0;
                top: 23.5px;
                line-height: 13px;
            }
            & .course_bubble_2 {
                width: 12.5px;
                height: 12.5px;
                left: 49px;
                top: 13.5px;
            }
            & .course_bubble_3 {
                width: 15px;
                height: 15px;
                left: 28px;
                top: 83.5px;
            }
            & .course_bubble_4 {
                width: 47px;
                height: 47px;
                left: 47.5px;
                top: 33.5px;
                line-height: 14px;
            }
            & .course_bubble_5 {
                width: 26px;
                height: 26px;
                left: 84.5px;
                top: 10px;
                line-height: 12px;
            }
            & .course_bubble_6 {
                width: 53px;
                height: 53px;
                left: 98px;
                top: 62px;
            }
            & .course_bubble_7 {
                width: 58.5px;
                height: 58.5px;
                left: 136.5px;
                top: 0px;
                line-height: 17px;
            }
            & .course_bubble_8 {
                width: 44.5px;
                height: 44.5px;
                left: 168.5px;
                top: 70.5px;
                line-height: 14px;
            }
            & .course_bubble_9 {
                width: 11.5px;
                height: 11.5px;
                left: 198.5px;
                top: 51px;
            }
            & .course_bubble_10 {
                width: 29.5px;
                height: 29.5px;
                left: 213px;
                top: 0px;
                line-height: 10px;
            }
            & .course_bubble_11 {
                width: 53px;
                height: 53px;
                left: 232px;
                top: 42px;
                line-height: 14px;
            }
            & .course_bubble_12 {
                width: 41px;
                height: 41px;
                left: 279.5px;
                top: 5px;
                line-height: 12px;
            }
            & .course_bubble_13 {
                width: 17.5px;
                height: 17.5px;
                left: 317.5px;
                top: 54.5px;
            }
        }
    }
}

.bg_c_g {
    padding: 36px 20px 46px;
    & > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 24px;
        & span {
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
        }
    }
    & .activity_list {
        display: flex;
    }
}
.opac_15 {
    opacity: 0.15;
}

.opac_4 {
    opacity: 0.4;
}

.opac_5 {
    opacity: 0.5;
}

.opac_7 {
    opacity: 0.7;
}

.opac_8 {
    opacity: 0.8;
}

.animation_1 {
    animation: buble 5s infinite;
}

.animation_2 {
    animation: buble 6s infinite;
}

.animation_3 {
    animation: buble 7s infinite;
}

.animation_4 {
    animation: buble 8s infinite;
}

.animation_5 {
    animation: buble 9s infinite;
}
.animation_6 {
    animation: buble 10s infinite;
}

.bubble_base {
    position: absolute;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

@keyframes head_content_text_animation {
    0% {
        opacity: 0;
        transform: translateY(-56.5px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
@keyframes buble {
    0% {
        transform: translateY(0px);
    }

    50% {
        transform: translateY(10px);
    }

    100% {
        transform: translateY(0px);
    }
}
</style>